export const ADD_ARTICLE = 'ADD_ARTICLE'
export const CLEAR_ARTICLES = 'CLEAR_ARTICLES'
export const CLEAR_TAGS = 'CLEAR_TAGS'
export const ADD_GENERAL_TAG = 'ADD_GENERAL_TAG'
export const ADD_USER_TAG = 'ADD_USER_TAG'
export const ADD_BANQUE = 'ADD_BANQUE'
export const ADD_MY_NEWS = 'ADD_MY_NEWS'



// WEBPACK FOOTER //
// ./src/common/store/News/types.js